import { render, staticRenderFns } from "./GroupsEdit.vue?vue&type=template&id=6cf6cf01&scoped=true"
import script from "./GroupsEdit.vue?vue&type=script&lang=js"
export * from "./GroupsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6cf01",
  null
  
)

export default component.exports